exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.max-height[data-v-a9e02b06] {\n    max-height: 45px !important;\n}\n@media all and (max-width: 800px) {\n.input-mobile-text[data-v-a9e02b06] {\n        font-size: 12px;\n}\n}\n", ""]);

// exports
